import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SecurityService {

  constructor(private http: HttpClient) {

  }

  /**
   *
   * @param param
   * @returns
   */
  authentication(param: any) {
    return this.http.post(`${environment.api_cm_security}/login`, param )
      .pipe(map(data => data));
  }

}
